import { useEffect, useState } from 'react';
import { CloseButton } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';

export default function GlobalNotice() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [notice, setNotice] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const info = searchParams.get('info');
    const providerRaw = searchParams.get('provider');

    if (info === 'provider_linked' && providerRaw) {
      const provider = providerRaw.charAt(0).toUpperCase() + providerRaw.slice(1);
      setNotice({ key: 'providerLinkedSuccess', params: { provider } });

      // Clean up URL
      searchParams.delete('info');
      searchParams.delete('provider');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  if (!notice) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{ backgroundColor: '#10b981', color: 'white', padding: '12px', textAlign: 'center', fontWeight: '500', zIndex: 1000, position: 'relative' }}
    >
      <span>{t(notice.key, '', notice.params)}</span>
      <CloseButton
        onClick={() => setNotice(null)}
        color="white"
        aria-label={t('dismissNotice', 'Dismiss notification')}
        style={{ marginLeft: '12px' }}
      />
    </div>
  );
}
